import store from '@/store'

export default async (_to, _from, next) => {
  const user = store.getters['auth/user']
  if (!user?.id) {
    next({ name: 'shared.login' })
  } else {
    next()
  }
}
